$.fn.extend
  shapesContainer: (options) ->
    input = 
      option1: "red"
    
    input = $.extend input, options

    # console.log settings.frames

    container = $(@)

    
    output = {
    
      insertShape: (shape_id, page, x, y) ->
         
          $.ajax(
            dataType: 'JSON'
            method: 'POST'
            data:
              app_url: window.location.pathname
              shape_id: shape_id
              x: (parseFloat(x - page.offset().left) / page.outerWidth()) * 100
              y: (parseFloat(y - page.offset().top) / page.outerHeight()) * 100
              page_number: page.data('page')
            url: '/ajax/app/shape_insert/'
          ).done((data) ->
              # frame.html data.new_frame_html
              loadPage()
              # output.init()
              return
          ).fail (jqXHR, textStatus) ->
              console.warn 'Error: ' + jqXHR.responseText
              return
          return

        reload: () ->
            showSmallLoader()

            console.log 'Shapes reloaded'
            $.ajax(
              dataType: 'JSON'
              method: 'POST'
              url: '/ajax/app/shapes_container/'
              data: 
                app_url: window.location.pathname
            ).done((data) ->
                hideSmallLoader()

                container.html data.html_output
 
                container.find('.shape').each ->
                    shape = $(@)
                    $(@).appObject
                      dropTarget: '.page'
                      afterDrop: (drop, dropCoords) ->
                        if drop
                          output.insertShape shape.data('shape_id'), drop, dropCoords.x, dropCoords.y
                          return

                    # $('.scrollbar').scrollbar();
            ).fail (jqXHR, textStatus) ->
              console.warn 'Error: ' + jqXHR.responseText
              return
            return 


            
    }

    # output.reload()

    return output